import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { aplicarTemaSalvo } from './lib/tema.ts';
import './estilos/global.css';

// Antes de montar: sem isto, quem usa o modo escuro vê um flash branco a cada
// abertura de página.
aplicarTemaSalvo();

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Não achei o elemento #raiz no index.html.');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
